<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row">
          <div class="col-lg-6 m-b-10 d-flex">
            <div class="card no-border card-condensed no-margin widget-loader-circle align-self-stretch d-flex flex-column">
              <div class="auto-overflow p-2">
                <h2 class="text-success text-center">{{ $t('menu_my_schedule') }}</h2>

                <div class="d-flex justify-content-between week-slider">
                  <b-button class="btn weekbutton"
                            @click="jumpWeek(-1)"><i class="fa fa-arrow-left"></i>
                  </b-button>
                  <div>
                    <span class="sectiontitle">{{ $t('schedule_week') }} {{ getMySchedule.Week }}
                      <span class="p-l-1"></span>
                      <span class="text-muted">{{ getMySchedule.Year }}</span>
                    </span>
                  </div>
                  <b-button class="btn weekbutton"
                            @click="jumpWeek(1)"><i class="fa fa-arrow-right"></i>
                  </b-button>
                </div>

                <table class="table table-sm cal-24" id="schedule-table">
                  <thead>
                    <tr>
                      <th class="text-center cal-border">
                        <calendar-icon class="icon-big"
                                       :title="$t('schedule_week')" />
                      </th>
                      <th class="text-center morning-border">
                        {{ $t('schedule_early') }}
                      </th>
                      <th class="text-center day-border">
                        {{ $t('schedule_day') }}
                      </th>
                      <th class="text-center night-border">
                        {{ $t('schedule_late') }}
                      </th>
                      <th class="text-center night-border">
                        {{ $t('schedule_night') }}
                      </th>
                      <th class="text-center off-border">
                        {{ $t('schedule_free') }}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(weekday, daynumber) in getMySchedule.Days">
                      <td>
                        <div class="daymonth">
                          <p class="days">{{ weekday.DayOfWeek }}</p>
                          <p class="date-month">{{ weekday.Date.split('-')[1] }}</p>
                          <p class="date-day">{{ weekday.Date.split('-')[0] }}</p>
                        </div>
                      </td>
                      <td v-for="shiftType in getShiftClass.typeId"
                          v-if="weekday.Selected === shiftType && weekday.Selected != 128"
                          class="text-center">
                        <button class="foodadvice">
                          <router-link
                            :to="{ name: 'advice', params: { shift_type: shiftType} }">
                            <span class="food"></span>
                          </router-link>
                        </button>
                      </td>
                      <td v-else
                          class="text-center">
                        <span class="material-icons"
                              @click="setAdvice(daynumber, shiftType)">
                          <work-shift-icon v-if="shiftType != 128" title="Work shift" />
                          <free-shift-icon v-else title="Free shift" />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CalendarIcon from "vue-material-design-icons/Calendar.vue"
  import WorkShiftIcon from "vue-material-design-icons/Briefcase.vue"
  import FreeShiftIcon from "vue-material-design-icons/AlarmOff.vue"
  import { mapGetters } from 'vuex'
  import { mapActions } from 'vuex'

  export default {
    components: {CalendarIcon, WorkShiftIcon, FreeShiftIcon},
    computed: {
      ...mapGetters([
        'getMySchedule',
        'getShiftClass',
      ]),
    },
    methods: {
      ...mapActions([
        'loadMySchedule',
        'jumpMySchedule',
        'saveMySchedule',
        'loadTimeBlockAdvice',
      ]),
      jumpWeek(jumpValue) {
        let jumpData = {
          year: this.getMySchedule.Year,
          week: this.getMySchedule.Week,
          jump: jumpValue,
        }
        this.jumpMySchedule(jumpData)
      },
      setAdvice(day_number, shift_type) {
        let saveData = {
          year: this.getMySchedule.Year,
          week: this.getMySchedule.Week,
          day: day_number,
          selected: shift_type,
        }
        this.saveMySchedule(saveData).then(response => {
          console.log(response)
          this.loadMySchedule(saveData)
          this.loadTimeBlockAdvice(saveData.selected)
        }, error => {
          console.error(error)
        })
      },
    },
    created() {
      this.loadMySchedule()
    },
  }
</script>

<style scoped>
  .foodadvice {
    width: 100%;
    max-width: 52px;
    max-height: 52px;
  }
</style>



// WEBPACK FOOTER //
// src/components/myschedule/Calendar.vue